import { queryOptions } from "@tanstack/react-query";
import { GET_FOOTPRINT_HISTORY_FOR_WEB } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { FootprintListResponse } from "./types";

/** 一覧の取得件数（固定取得。ページネーションは行わない） */
const FOOTPRINT_TAKE = 72;

export const footprintListQueryOptions = queryOptions({
  queryKey: queryKeys.footprint.list(),
  queryFn: () =>
    apiClient<FootprintListResponse>(GET_FOOTPRINT_HISTORY_FOR_WEB, {
      skip: 0,
      take: FOOTPRINT_TAKE,
    }),
});
